import { VariableType } from "../VariableType";
import { BaseNumberSchema } from "./BaseNumberSchema";

export class MediumIntSchema extends BaseNumberSchema
{
    constructor(required: boolean, min: number | null = null, max: number | null = null)
    {
        super(VariableType.MediumInt, required, min, max);
    }
}